__turbopack_context__.v({
  "className": "caveat_7598186f-module__6GWxXq__className",
  "variable": "caveat_7598186f-module__6GWxXq__variable",
});
